module.exports = __webpack_public_path__ + "static/media/qrcode-android-mweb.a569c723.webp";